<template>
  <div class="alertContainer"  :class="className">
      <div class="card bg-warning cardContainer">
        <div class="card-header">
          <h5 class="card-title text-white">Silme işlemi</h5>
        </div>
        <div class="card-body text-white">
          Silme işlemini onaylıyor musun? Bu işin geri dönüşü yoktur?
          <br/>
          Silinecek içerik: <strong>{{title}}</strong>
        </div>

        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <Button title="Vazgeç" :onclick="cancel" class-name="btn-secondary"/>
            <Button title="Sil" :onclick="onOkey" class-name="btn-danger"/>

          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Button from '@/components/forms/Button'
export default {
  name: 'DeleteAlert',
  components: {
    Button
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    onOkey: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      showBox: this.show
    }
  },
  watch: {
    show: function (val) {
      this.showBox = this.show
    }
  },
  methods: {
    cancel: function () {
      this.showBox = false
      this.$emit('show-box-changed', false)
    }
  },
  computed: {
    className () {
      return this.showBox ? 'show' : ''
    }
  }
}
</script>

<style scoped>
  .alertContainer{
    width:0;
    height:0;
    position: fixed;
    top:0;
    left:0;
    z-index: 100000000;
    justify-content: center;
    align-items: center;
    transition: all 0.2s linear;
    display: flex;
    overflow: hidden;
  }
  .show{
    width:100vw;
    height:100vh;
  }

</style>
